<template>
  <div class="fieldMain" :style="{
      'align-items': (fieldData['properties']['textAlign'] == 'top' ? 'flex-start' : fieldData['properties']['textAlign'] == 'bottom' ? 'flex-end' : fieldData['properties']['textAlign']),
      'justify-content': (fieldData['properties']['textJustify'] == 'left' ? 'flex-start' : fieldData['properties']['textJustify'] == 'right' ? 'flex-end' : fieldData['properties']['textJustify']),

      'background-color': showKeyData ? '#0000' : colorData[fieldData['properties']['type']]['background'],
      'border': showKeyData ? 'none' : ('solid 1px ' + colorData[fieldData['properties']['type']]['border']) }"
    @mousedown="fieldMouseDown($event)">

    <div class='fieldTextMain' v-html="mainData['text']" v-if="fieldData['properties']['type'] == 'text'" :style="{
      'text-align': fieldData['properties']['textJustify'],
      'margin': (fieldData['properties']['textAlign'] == 'center' ? 'auto' : ''),

      'font-family': fieldData['properties']['textFamily'],
      'font-size': (((fieldData['properties']['textSize'] * toolbarData['zoomLevel']) * pageData['textptpx']) + 'px'),
      'line-height': (((fieldData['properties']['textSize'] * toolbarData['zoomLevel']) * pageData['textptpx'] * 1.25) +'px'),
      'font-weight': fieldData['properties']['textWeight'],
      'color': fieldData['properties']['textColor'] }"></div>

    <div class='fieldTableMain' v-if="fieldData['properties']['type'] == 'table'" :style="{
      'text-align': fieldData['properties']['textJustify'],
      'margin': (fieldData['properties']['textAlign'] == 'center' ? 'auto' : ''), }">
    
      <!-- {{fieldData['properties']['tableRow']}}
      {{fieldData['properties']['tableCol']}}
      {{fieldData['height']}}
      {{fieldData['height'] / ((fieldData['properties']['tableRow'] == 0) ? 1 : fieldData['properties']['tableRow'])}}
      {{fieldData['id']}} -->

      <div class="fieldTableRow" v-for="r in parseInt(fieldData['properties']['tableRow'])" :key="fieldData['id'] +'Row' + r" :style="{
          'max-height': ((fieldData['height'] * toolbarData['zoomLevel']) / ((fieldData['properties']['tableRow'] == 0) ? 1 : fieldData['properties']['tableRow']) + 'px'),
          'border-top': ((fieldData['properties']['tableBorder'] && showKeyData && (r == 1)) ? 'solid 1px black' : ((r == 1) ? (!showKeyData ? 'solid 1px gray' : '')  : '')),
          'border-bottom': ((fieldData['properties']['tableBorder'] && showKeyData) ? 'solid 1px black' : !showKeyData ? 'solid 1px gray' : ''), }">
          
        <div class="fieldTableCol" v-for="c in parseInt(fieldData['properties']['tableCol'])" :key="fieldData['id'] +'Col' + c" :style="{
          'max-width': ((fieldData['width'] * toolbarData['zoomLevel']) / ((fieldData['properties']['tableCol'] == 0) ? 1 : fieldData['properties']['tableCol']) + 'px'),
          'border-left': ((fieldData['properties']['tableBorder'] && showKeyData && (c == 1)) ? 'solid 1px black' : ((c == 1) ? (!showKeyData ? 'solid 1px gray' : '')  : '')),
          'border-right': ((fieldData['properties']['tableBorder'] && showKeyData) ? 'solid 1px black' : !showKeyData ? 'solid 1px gray' : ''),
          
          'font-family': fieldData['properties']['textFamily'],
          'font-size': (((fieldData['properties']['textSize'] * toolbarData['zoomLevel']) * pageData['textptpx']) + 'px'),
          'line-height': (((fieldData['properties']['textSize'] * toolbarData['zoomLevel']) * pageData['textptpx'] * 1.25) +'px'),
          'font-weight': fieldData['properties']['textWeight'],
          'color': fieldData['properties']['textColor'] }">
          <!-- {{fieldData['properties']['tableBorder']}} -->
          {{showKeyData ? '' : (r == 1) ? (fieldData['properties']['tableKey'] ? (mainData['tableKeys'][c - 1] ? mainData['tableKeys'][c - 1]['key'] : '') : '') : ''}}

          {{showKeyData ? (fieldData['properties']['tableKey'] ? (keyData[fieldData['properties']['tableKey']][(parseInt(fieldData['properties']['tableSeq']) + (r - 1)) - 1] ? 
              keyData[fieldData['properties']['tableKey']][(parseInt(fieldData['properties']['tableSeq']) + (r - 1)) - 1][(mainData['tableKeys'][c - 1] ? mainData['tableKeys'][c - 1]['key'] : '')] : '') : '') : ''}}
        </div>
      </div>
    </div>
      

  </div>
</template>

<script>
  /* eslint-disable */
  
  
  export default {
    name: 'reportField',
    components: {
      
    },
    props: {
      pageData: { type: Object, default: function() { return {} }},
      toolbarData: { type: Object, default: function() { return {} }},
      fieldData: { type: Object, default: function() { return {} }},

      keyData: { type: Object, default: function() { return {} }},
      showKeyData: false,
    },
    data() { 
      return {
        mainData: {
          'text': '',
          'tableKeys': [],
        },
        test: '',



        colorData: {
          'text': { 'border': '#00ff08aa', 'background': '#00ff0822' },
          'table': { 'border': '#3ec3f0aa', 'background': '#3ec3f022' },
        },
      }
    },
    mounted() {
      this.fieldFormat();
    },
    beforeDestroy() {
      
    },
    methods: {
      fieldFormat: async function() {
        switch(this.fieldData['properties']['type']) {
          case 'text':
            //---- Set variables
            var text = JSON.parse(JSON.stringify(this.fieldData['properties']['value']));
            var match = [];
            var pattern = /{([^}]*)}/g;

            //---- Get keys found in text
            var textKeys = [];
            while (match = pattern.exec(text)) { textKeys.push(match[0]); }
            // if (textKeys['length'] > 0) { console.log(textKeys); }

            //---- Replace all newlines to breaklines
            text = text.replace(/\r|\n/g, '<br>');
            //---- Replace keys with boxes/indicators
            textKeys.forEach((k) => {
              if (this.showKeyData) {
                var keyValue = this.keyData[k.replace(/\{|\}/g, '')] ? this.keyData[k.replace(/\{|\}/g, '')] : '';
                text = text.replace(k, keyValue);
              } else {
                text = text.replace(k, '<span class="fieldKey">' + k.replace(/\{|\}/g, '') + '</span>');
              }
            });

            //---- Apply formatted text into field
            this.$set(this.mainData, 'text', text);
            break;
          case 'table':
            //---- Set variables
            var text = JSON.parse(JSON.stringify(this.fieldData['properties']['value']));
            var match = [];
            var pattern = /{([^}]*)}/g;
            this.test = text

            //---- Get keys found in text
            var textKeys = [];
            while (match = pattern.exec(text)) { textKeys.push(match[0]); }
            
            this.$set(this.mainData, 'tableKeys', []);
            if (textKeys['length'] > 0) {
              // textKeys.forEach((k) => { this.mainData['tableKeys'].push(k.replace(/\{|\}/g, '')); });
              textKeys.forEach((k) => { this.mainData['tableKeys'].push(JSON.parse(k)); });
            }
            // console.log(this.mainData['tableKeys']);
            break;
        }
      },


      fieldMouseDown: async function(e) {
        this.$emit('mousedown', e);
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      showKeyData: { deep: true, handler(h) { this.fieldFormat(); } },
      "fieldData.properties": { deep: true, handler(h) { this.fieldFormat(); } },
    },
  };
</script>

<style scoped>

  .fieldMain {
    width: auto;
    height: auto;
    display: flex;
    position: absolute;
    background-color: #0001;
    border: solid 1px #0003;
    /* white-space: pre; */
  }

  .fieldTextMain {
    width: auto;
    height: auto;
    position: absolute;
    user-select: none;
    pointer-events: none;
  }

  .fieldTableMain {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    pointer-events: none;
  }

  .fieldTableRow {
    width: 100%;
    height: auto;
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .fieldTableCol {
    width: auto;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>

<style>
  .fieldKey {
    padding: 0 2px;
    background-color: #0002;
    border: solid 1px #0004;
  }
</style>